import {
  GET_TEAMS_REQUEST_START,
  GET_TEAMS_REQUEST_SUCCESS,
  GET_TEAMS_REQUEST_ERROR,
} from "actions/app";
import {
  createRequestReducers,
  requestReducerStart,
  requestReducerSuccess,
  requestReducerError,
} from "util/reducers";

function getInitialState() {
  return {
    requests: createRequestReducers(["getTeams"]),
    teams: null,
  };
}

export default function (state = getInitialState(), action) {
  const { type, teams, error } = action;

  switch (type) {
    case GET_TEAMS_REQUEST_START:
      return {
        ...state,
        requests: requestReducerStart(state.requests, "getTeams"),
      };

    case GET_TEAMS_REQUEST_SUCCESS:
      return {
        ...state,
        requests: requestReducerSuccess(state.requests, "getTeams"),
        teams,
      };

    case GET_TEAMS_REQUEST_ERROR:
      return {
        ...state,
        requests: requestReducerError(state.requests, "getTeams", error),
        error,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js